export default class Glossy {
	static init() {
		this.elements = document.querySelectorAll(".glossy");

		this.elements.forEach( (element) => {

			const glossy = document.createElement("span");
			glossy.classList.add("glossy-effect");
			element.classList.add("item-on-hover");
			element.prepend(glossy);

		});

	}

}
